import React from 'react'
import { useDispatch } from 'react-redux'
import { css } from '@emotion/react'

import LogoutIcon from 'gatsby-theme-marketplace-base/src/assets/icons/logout.inline.svg'
import { userLogOut } from 'gatsby-theme-marketplace-base/src/store/user'

const logoutCss = (theme) => css`
  display: flex;
  align-items: center;
  margin: 10px 0 10px 25px;
  font-size: 16px;
  line-height: 1.75;

  &:hover {
    color: ${theme.colors.blueRibbon};
    cursor: pointer;
  }

  > svg {
    fill: ${theme.colors.error};
    margin-right: 10px;
  }
`

const DevLogout = () => {
  const dispatch = useDispatch()
  const onLogoutClick = () => dispatch(userLogOut.pending())

  return (
    <div onClick={onLogoutClick} css={logoutCss}>
      <LogoutIcon />
      <span>Logout</span>
    </div>
  )
}

export default DevLogout
